import React from 'react';
import type { GetStaticProps, NextPage } from 'next';
import Router from 'next/router';
import { getBlogArticles } from 'day8-react/build/content';
import PageLayout from '../../../layouts/page';
import BlogPageWrapper from '../../../components/blog/BlogPageWrapper';
import { sanitizeWpResponse } from '../../../helpers/wp';
import { WpPageType } from '../../../globalTypes';

type BlogPage = {
  page: number
  posts: WpPageType[]
  pagesCount: number
}

const BlogPage: NextPage<BlogPage> = ({
  posts,
  page,
  pagesCount
}) => {
  const handlePageChange = (pageNumber: number) => Router.push(`/blog/page/${pageNumber}`).then(() => window.scrollTo(0, 0));
  return (
    <PageLayout page={{ seo_title: 'Blog | The Ski Week' }} hiddenCurrency>
      <BlogPageWrapper page={page} pagesCount={pagesCount} posts={posts} handlePageChange={handlePageChange} heading="Go on, have a scroll" subheading="Read our blog" />
    </PageLayout>
  );
};
export async function getStaticPaths() {
  const perPage = 12;
  const postsResponse = await getBlogArticles(1, null, undefined, perPage);
  const pagesCount = Math.floor(postsResponse.pagesCount) > 2 ? 2 : Math.floor(postsResponse.pagesCount);
  const paths = Array.from(Array(pagesCount).keys()).map(page => ({
    params: {
      page: `${page + 1}`
    }
  }));
  return {
    paths,
    fallback: 'blocking'
  };
}
type PostResponse = {
  pagesCount: number
  posts: WpPageType[]
}
export const getStaticProps: GetStaticProps = async ({ params }) => {
  const perPage = 12;
  const page = params?.page;
  const postsResponse: PostResponse = await getBlogArticles(page, null, undefined, perPage);
  const pagesCount = Math.floor(postsResponse.pagesCount);
  return {
    props: {
      posts: postsResponse?.posts.map(post => sanitizeWpResponse(post)) || [],
      page,
      pagesCount
    },
    revalidate: 600
  };
};
export default BlogPage;
